export const DIRECT_ORDERING_LIST_ITEMS = [
  'Accurate estimates for multiple trades',
  'Dependable materials list',
  'Supplier-direct ordering with zero manual entry',
];

export const LABOR_MANAGEMENT_LIST_ITEMS = [
  'Labor lists for multiple trades',
  'Pre-populated work orders',
  'Keep work on-site on-track',
];
